export enum Role {
  PRACTITIONER,
  COORDINATOR,
  SPECIALIST,
  CLIENT,
  ADMIN
}



// WEBPACK FOOTER //
// C:/Users/Sylwia/Desktop/12.02/ecv_manager_frontend/src/app/enums/role.enum.ts